import { getIconName } from "@/mixins/icon";

export function useMenuItems() {
  const items = {
    home: {
      to: { name: "home" },
      title: "menu.home",
    },
    customise_remote: {
      to: { name: "customise-remote" },
      title: "menu.customise_remote",
      additional: true,
    },
    entities: {
      to: { name: "entities" },
      title: "menu.entities",
    },
    integrations: {
      to: { name: "integrations" },
      title: "menu.integrations",
    },
    activities_macros: {
      to: { name: "activities-macros" },
      title: "menu.activities_macros",
    },
    settings: {
      to: { name: "settings" },
      title: "menu.settings",
    },
  };

  async function getSettingsItems() {
    const iconSound = await getIconName('fa-volume');
    return [
      { value: 'general', label: "settings.general.name", icon: 'fa-light fa-gear' },
      { value: 'display', label: "settings.display.name", icon: 'fa-light fa-display' },
      // { value: 'user-interface', label: "settings.user_interface.name", icon: 'fa-light fa-sidebar' },
      { value: 'sound-haptic', label: "settings.sound_haptic.name", icon: `fa-light ${iconSound}` },
      { value: 'voice-control', label: "settings.voice_control.name", icon: 'fa-light fa-microphone' },
      { value: 'power-saving', label: "settings.power_saving.name", icon: 'fa-light fa-battery-three-quarters' },
      { value: 'wifi-bluetooth', label: "settings.wifi_bluetooth.name", icon: 'fa-light fa-wifi' },
      { value: 'localization', label: "settings.localization.name", icon: 'fa-light fa-globe' },
      { value: 'admin-password', label: "settings.admin_password.name", icon: 'fa-light fa-lock' },
      { value: 'application-credentials', label: "settings.application_credentials.name", icon: 'fa-light fa-key' },
      { value: 'development', label: "settings.development.name", icon: 'fa-light fa-code' },
      { value: 'factory-reset', label: "settings.factory_reset.name", icon: 'fa-light fa-warning' },
    ] 
  };

  function fromEntries(entries: [string, any][]) {
    return entries.reduce((acc: Record<string, any>, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});
  };

  function getMenuItems(base: boolean = false) {
    if (base) {
      return fromEntries(
        Object.entries(items).filter(
          ([key, value]) => !('additional' in value && value.additional)
        )
      );
    }

    return items;
  }

  return {
    getMenuItems,
    getSettingsItems
  };
}
